import { FileUploadFileValidation } from '@bbl-digital/snorre-v2'

export type FileWrapper = {
  file?: File
  isLocal: boolean
  isExisting: boolean
  isArchive: boolean
  id: string
  name: string
  size?: number
  validation?: FileUploadFileValidation
  mimeType?: string
  url?: string
}

export enum Step {
  LOCAL = 'local',
  ARCHIVE = 'archive',
}
